const PREFIX = 'NOTIFICATIONS / '

const SYSTEM = `${PREFIX}SYSTEM`
const LOCAL = `${PREFIX}LOCAL`

const CREATE = '_CREATE'
const REMOVE = '_REMOVE'

// LOCAL NOTIFICATIONS
export const LOCAL_CREATE = LOCAL + CREATE
export const LOCAL_REMOVE = LOCAL + REMOVE

// SYSTEM NOTIFICATIONS
export const SYSTEM_CREATE = SYSTEM + CREATE
export const SYSTEM_REMOVE = SYSTEM + REMOVE

export const INITIAL_STATE = {
  local: [],
  system: [],
}
